import {
  Modal,
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";

type ShippingLine = {
  _id: string;
  liner: string;
  scacCode: string;
  abbreviation: string;
};

interface Props {
  open: boolean;
  handleClose: () => void;
  shippingLines: ShippingLine[];
}

const boxStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  // boxShadow: 24,
  borderRadius: 2,
  // p: 3,
  maxHeight: "90vh",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export default function OceanShippingShowModal({
  open,
  handleClose,
  shippingLines,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={boxStyle}>
  
        <div className="modalTableHeading">
          <h3 id="modal-modal-title">Active Shipping Lines</h3>
        </div>
        <div className="tableModalBody">
          <div className="tableModalResponsive">
            <TableContainer
              component={Paper}
              sx={{
                flex: 1,
                overflowY: "auto",
                maxHeight: "100%",
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Shipping Line</TableCell>
                    <TableCell>SCAC Code</TableCell>
                    <TableCell>Abbreviation</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {shippingLines?.length > 0 ? (
                    shippingLines.map((line) => (
                      <TableRow key={line._id}>
                        <TableCell>{line.liner}</TableCell>
                        <TableCell>{line.scacCode}</TableCell>
                        <TableCell>{line.abbreviation}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
